/** @format */

import { Button, Card, Col, Grid, Row } from "antd";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "next-i18next";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import { convert } from "html-to-text";

import axios from "axios";

import responsiveColumn from "../../../methods/responsiveColumn";
import Link from "next/link";
import type { Articles } from "../../../interfaces/articles";

export default function TaxGroup() {
  const textContainer = useRef(null);
  const { t } = useTranslation("practice_areas_section3");

  const [areas, setAreas] = useState<Articles>();
  const [controversy, setControversy] = useState<Articles>();

  const { useBreakpoint } = Grid;
  const screenSize = useBreakpoint();

  const fetchArticles = async () => {
    try {
      const r = await axios({
        url: "https://wp.taxworkoutgroup.com/wp-json/wp/v2/practice_areas?_embed&per_page=100&categories=14",
        method: "get",
      });

      setAreas(
        r.data?.sort((a: any, b: any) => a.acf.priority - b.acf.priority)
      );
    } catch (e) {
      console.log(e);
    }
  };
  const fetchControversy = async () => {
    try {
      const r = await axios({
        url: "https://wp.taxworkoutgroup.com/wp-json/wp/v2/practice_areas?_embed&per_page=100&categories=17",
        method: "get",
      });

      setControversy(
        r.data?.sort((a: any, b: any) => a.acf.priority - b.acf.priority)
      );
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    fetchArticles();
    fetchControversy();
  }, []);

  return (
    <>
      <Row
        style={{
          padding: "50px 0",
          paddingRight: 15,
          paddingLeft: 15,
          lineHeight: 1.5,
        }}
        gutter={[40, 40]}
        justify='center'>
        <Col {...responsiveColumn([17, 22, 23, 24, 24, 24])}>
          <Row justify='center' gutter={[20, 20]}>
            <Col ref={textContainer} lg={10} md={10} sm={24}>
              <Row gutter={[20, 20]}>
                <Col
                  span={24}
                  style={{
                    fontSize: 20,
                  }}>
                  <h2
                    className='section_title'
                    style={{
                      fontSize: screenSize.md ? 48 : 33,
                    }}>
                    {t("section3_title")}
                  </h2>
                </Col>
                <Col
                  span={24}
                  style={{
                    fontSize: 20,
                  }}>
                  <b>{t("section3_p1")}</b>
                </Col>

                <Col span={24} style={{ fontSize: 16, lineHeight: "24px" }}>
                  <p>{t("section4_p2")}</p>
                </Col>
                <Col span={24}>
                  <Link href='/taxbankruptcy'>
                    <Button
                      size='large'
                      type='primary'
                      style={{ fontSize: 15, padding: "0 30px" }}>
                      {t("section3_button")}
                    </Button>
                  </Link>
                </Col>
              </Row>
            </Col>
            <Col offset={3} span={10}>
              {/* <div>dbfjksjhdk</div> */}
              <Row gutter={[20, 20]}>
                {areas?.slice(0, 6)?.map((service) => {
                  return (
                    <Col
                      lg={12}
                      md={12}
                      sm={24}
                      key={service.id}
                      style={{
                        textAlign: screenSize.md ? "right" : "left",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}>
                      <Link
                        style={{
                          color: "#fff",
                          fontSize: 16,
                          fontWeight: screenSize.md ? 500 : 400,
                        }}
                        href={`/taxbankruptcy/${service.slug}`}>
                        <Card
                          className={"hoverable-tile"}
                          hoverable
                          style={{
                            height: 112,
                            width: screenSize.md ? "" : "300px",
                            maxWidth: screenSize.md ? "270px" : "",
                            textAlign: "center",
                            background: "#254486",
                            fontWeight: screenSize.md ? 600 : 500,
                            color: "#fff",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            boxShadow: "-9px 9px 15px rgb(0 0 0 / 50%)",
                          }}>
                          {convert(service.title?.rendered)}
                        </Card>
                      </Link>
                    </Col>
                  );
                })}
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row
        style={{
          padding: "50px 0",
          paddingRight: 15,
          paddingLeft: 15,
          lineHeight: 1.5,
        }}
        gutter={[40, 40]}
        justify='center'>
        <Col {...responsiveColumn([17, 22, 23, 24, 24, 24])}>
          <Row
            gutter={[20, 20]}
            justify='center'
            style={{
              display: "flex",
            }}>
            <Col
              xs={{ span: 24, order: 2 }}
              sm={{ span: 24, order: 2 }}
              md={{ span: 10, order: 1 }}
              lg={{ span: 10, order: 1 }}>
              <Row gutter={[20, 20]}>
                {controversy?.slice(0, 6)?.map((service) => {
                  return (
                    <Col
                      lg={12}
                      md={12}
                      sm={24}
                      key={service.id}
                      style={{
                        textAlign: screenSize.md ? "right" : "left",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}>
                      <Link
                        style={{
                          color: "#fff",
                          fontSize: 16,
                          fontWeight: screenSize.md ? 500 : 400,
                        }}
                        href={`/taxbankruptcy/${service.slug}`}>
                        <Card
                          className={"hoverable-tile"}
                          hoverable
                          style={{
                            height: 112,
                            width: screenSize.md ? "300px" : "",
                            maxWidth: screenSize.lg ? "270px" : "",
                            textAlign: "center",
                            background: "#254486",
                            fontWeight: screenSize.md ? 600 : 500,
                            color: "#fff",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            boxShadow: "-9px 9px 15px rgb(0 0 0 / 50%)",
                          }}>
                          {convert(service.title?.rendered)}
                        </Card>
                      </Link>
                    </Col>
                  );
                })}
              </Row>
            </Col>
            <Col
              ref={textContainer}
              offset={3}
              xs={{ span: 24, order: 1 }}
              sm={{ span: 24, order: 1 }}
              md={{ span: 10, order: 2 }}
              lg={{ span: 10, order: 2 }}>
              <Row gutter={[20, 20]}>
                <Col
                  lg={24}
                  md={24}
                  sm={24}
                  style={{
                    fontSize: 20,
                  }}>
                  <h2
                    className='section_title'
                    style={{
                      fontSize: screenSize.md ? 48 : 33,
                    }}>
                    {t("section4_title2")}
                  </h2>
                  <b>{t("section3_p3")}</b>
                </Col>
                <Col
                  lg={24}
                  md={24}
                  sm={24}
                  style={{ fontSize: 16, lineHeight: "24px" }}>
                  <p>{t("section3_p4")}</p>
                </Col>
                <Col lg={24} md={24} sm={24}>
                  <Link href='/taxcontroversy'>
                    <Button
                      size='large'
                      type='primary'
                      style={{ fontSize: 15, padding: "0 30px" }}>
                      {t("section3_button")}
                    </Button>
                  </Link>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}
